var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.33326L10.6666 4.99993M1.08325 17.9166L3.90356 17.6032C4.24813 17.5649 4.42042 17.5458 4.58146 17.4937C4.72433 17.4474 4.86029 17.3821 4.98566 17.2994C5.12696 17.2062 5.24954 17.0836 5.49469 16.8385L16.4999 5.83326C17.4204 4.91279 17.4204 3.4204 16.4999 2.49993C15.5795 1.57945 14.0871 1.57945 13.1666 2.49992L2.16136 13.5052C1.91621 13.7503 1.79363 13.8729 1.70045 14.0142C1.61778 14.1396 1.55243 14.2755 1.50618 14.4184C1.45405 14.5794 1.43491 14.7517 1.39662 15.0963L1.08325 17.9166Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEdit;